import {
  Dialog,
  TextField,
  List,
  ListItemButton,
  ListItemText,
  Typography,
  Box,
  Chip,
} from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { setGlobalSearch } from '../../redux/uiSlice';
import { useListTasksQuery } from '../../redux/firestoreApi';
import { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { TASK_STATUS_META } from '../../types/models';

export default function GlobalSearch() {
  const open = useAppSelector((s) => s.ui.globalSearchOpen);
  const uid = useAppSelector((s) => s.session.uid);
  const projectId = useAppSelector((s) => s.session.activeProjectId);
  const sprintId = useAppSelector((s) => s.session.activeSprintId);
  const dispatch = useAppDispatch();
  const nav = useNavigate();
  const [q, setQ] = useState('');

  const tasks = useListTasksQuery(
    uid && projectId && sprintId
      ? { uid, projectId, sprintId }
      : (undefined as any),
    { skip: !uid || !projectId || !sprintId },
  );

  const results = useMemo(() => {
    if (!q.trim()) return [];
    const needle = q.toLowerCase();
    return (tasks.data ?? [])
      .filter(
        (t) =>
          t.ticketNo?.toLowerCase().includes(needle) ||
          t.title?.toLowerCase().includes(needle) ||
          t.assignee?.toLowerCase().includes(needle) ||
          t.status?.toLowerCase().includes(needle),
      )
      .slice(0, 25);
  }, [q, tasks.data]);

  const close = () => {
    setQ('');
    dispatch(setGlobalSearch(false));
  };

  return (
    <Dialog open={open} onClose={close} fullWidth maxWidth="sm">
      <Box sx={{ p: 2 }}>
        <TextField
          autoFocus
          placeholder="Search tickets, assignees, statuses…"
          value={q}
          onChange={(e) => setQ(e.target.value)}
          fullWidth
        />
      </Box>
      <List sx={{ maxHeight: 420, overflow: 'auto', pb: 1 }}>
        {q && results.length === 0 && (
          <Typography sx={{ px: 3, py: 2 }} color="text.secondary">
            No matches in current sprint.
          </Typography>
        )}
        {results.map((t) => (
          <ListItemButton
            key={t.id}
            onClick={() => {
              close();
              nav('/tasks');
            }}
          >
            <ListItemText
              primary={
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <Typography component="span" sx={{ fontFamily: 'monospace' }}>
                    {t.ticketNo}
                  </Typography>
                  <Typography component="span">{t.title}</Typography>
                </Box>
              }
              secondary={
                <Box sx={{ display: 'flex', gap: 1, mt: 0.5 }}>
                  <Chip
                    size="small"
                    label={`${TASK_STATUS_META[t.status].icon} ${TASK_STATUS_META[t.status].label}`}
                  />
                  {t.assignee && <Chip size="small" label={t.assignee} />}
                </Box>
              }
            />
          </ListItemButton>
        ))}
      </List>
    </Dialog>
  );
}
